// src/utils/push.js — enregistrement aux notifications push (app native uniquement)
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { fetchWithAuth } from "./api";

let listenersReady = false;

export function isNativePush() {
    return !!(Capacitor?.isNativePlatform && Capacitor.isNativePlatform());
}

// Branche les listeners une seule fois (token → backend, erreurs).
function ensureListeners() {
    if (listenersReady) return;
    listenersReady = true;

    PushNotifications.addListener("registration", async (token) => {
        try {
            await fetchWithAuth(`${process.env.REACT_APP_API_URL}/register-push-token`, {
                method: "POST",
                body: JSON.stringify({ token: token.value, platform: Capacitor.getPlatform() }),
            });
        } catch (e) {
            console.error("[push] enregistrement token :", e);
        }
    });

    PushNotifications.addListener("registrationError", (err) => {
        console.error("[push] registrationError :", err);
    });
}

// État de la permission : "granted" | "denied" | "prompt" | "prompt-with-rationale" | "web" | "unavailable"
export async function getPushPermission() {
    if (!isNativePush()) return "web";
    try {
        const p = await PushNotifications.checkPermissions();
        return p.receive;
    } catch (e) {
        console.error("[push] checkPermissions :", e);
        return "unavailable";
    }
}

// Enregistre le token (permission déjà accordée). Silencieux.
async function registerToken() {
    ensureListeners();
    await PushNotifications.register();
}

// Demande la permission OS puis enregistre. Retourne true si accordé.
export async function requestAndRegisterPush() {
    if (!isNativePush()) return false;
    try {
        let perm = await PushNotifications.checkPermissions();
        if (perm.receive === "prompt" || perm.receive === "prompt-with-rationale") {
            perm = await PushNotifications.requestPermissions();
        }
        if (perm.receive !== "granted") return false;
        await registerToken();
        return true;
    } catch (e) {
        console.error("[push] requestAndRegisterPush :", e);
        return false;
    }
}

// Au démarrage (connecté) : si la permission est déjà accordée, on (ré)enregistre
// le token silencieusement. On NE demande PAS la permission ici — c'est le rôle
// de l'écran de pré-explication (PushPrimer) qui appelle requestAndRegisterPush.
export async function initPush() {
    if (!isNativePush()) return;
    try {
        const perm = await PushNotifications.checkPermissions();
        if (perm.receive === "granted") {
            await registerToken();
        }
    } catch (e) {
        console.error("[push] initPush :", e);
    }
}
